<template>
  <div
    v-if="title || text || textAdditional"
    class="info-message"
    :class="{
      'info-message--info': type === 'info',
      'info-message--blue': type === 'blue',
      'info-message--delivery': type === 'delivery',
      'info-message--warn': type === 'warn',
      'info-message--error': type === 'error',
      'info-message--with-tooltip': withTooltip,
      'info-message--centered': centered
    }"
  >
    <div class="info-message__title-wrap">
      <img v-if="type === 'delivery' && !showDeliveryStatus" src="/img/svgo/cart/truck.svg" alt="">
      <h3 v-if="title" class="info-message__title" v-html="title"></h3>
    </div>
    <div class="delivery-status" v-if="showDeliveryStatus">
      <div class="delivery-status__current" :style="{'width': currentPercent + '%'}">
        <img src="/img/svgo/cart/truck.svg" alt="">
      </div>
      <div class="delivery-status__empty"></div>
    </div>
    <template v-if="!withTooltip">
      <p v-if="text" class="info-message__text">{{ text }}</p>
      <p v-if="textAdditional" class="info-message__text-additional">{{ textAdditional }}</p>
    </template>
    <InfoButton
      v-else
      class="info-message__info-btn"
      tooltip-horizontal-align="right"
      tooltip-vertical-align="center"
      :tooltip-text="text"
      max-tooltip-width="240px"
    />
  </div>
</template>

<script>
import InfoButton from './InfoButton'
import { mapGetters, mapState } from 'vuex'
import { NOVA_POSHTA_PRICE_LIMIT, NOVA_POSHTA_COURIER_PRICE_LIMIT, UKR_POSHTA_PRICE_LIMIT, COURIER_PRICE_LIMIT, NOVA_POSHTA_POSTOMAT_PRICE_LIMIT } from '@/constants'

export default {
  name: 'InfoMessage',
  components: { InfoButton },
  computed: {
    ...mapState({
      cart: state => state.cart.cart,
      deliveryType: state => state.checkout.formData.deliveryType
    }),
    ...mapGetters([
      'currentBonuses'
    ]),
    currentPercent () {
      let priceLimit = Math.min(NOVA_POSHTA_PRICE_LIMIT, NOVA_POSHTA_COURIER_PRICE_LIMIT, UKR_POSHTA_PRICE_LIMIT, COURIER_PRICE_LIMIT, NOVA_POSHTA_POSTOMAT_PRICE_LIMIT)
      if (this.deliveryType?.methodId === 5) {
        priceLimit = UKR_POSHTA_PRICE_LIMIT
      }
      if (this.deliveryType?.methodId === 3 || this.deliveryType === 9) {
        priceLimit = NOVA_POSHTA_PRICE_LIMIT
      }
      if (this.deliveryType?.methodId === 2) {
        priceLimit = COURIER_PRICE_LIMIT
      }
      if (this.deliveryType?.methodId === 4) {
        priceLimit = NOVA_POSHTA_COURIER_PRICE_LIMIT
      }
      if (this.deliveryType?.methodId === 7) {
        priceLimit = NOVA_POSHTA_POSTOMAT_PRICE_LIMIT
      }
      return Math.floor((this.cart.originCost - parseInt(this.currentBonuses)) * 100 / (priceLimit + 1))
    }
  },
  props: {
    showDeliveryStatus: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'info'
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    textAdditional: {
      type: String,
      default: ''
    },
    withTooltip: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="sass">
.delivery-status
  display: flex
  padding-top: 18px
  margin-bottom: 3px
  margin-right: -22px
  &__current
    height: 4px
    background-color: #FF2F00
    position: relative
    img
      position: absolute
      right: 0
      top: 50%
      transform: translate(50%, -50%)
      max-width: unset
  &__empty
    height: 4px
    background-color: #FFF
    flex-grow: 1
.info-message
  position: relative
  display: block
  width: 100%
  padding: 15px
  border: 1px solid
  border-radius: 3px

  &--centered
    padding: 25px 15px

  &--with-tooltip
    padding: 15px 40px 15px 15px

  &--info
    border-color: $nd-valid-border-color
    background-color: rgba(85, 202, 83, 0.1)

  &--blue
    border-color: #3E77AA
    background-color: rgba(#3E77AA, 0.1)
    padding: 5px 40px 5px 15px !important
    .info-message__info-btn
      top: 5px
      right: 8px
    .info-message__title
      font-size: 12px
      font-weight: 400
      line-height: 1.1

  &--error
    border-color: $nd-error-border-color
    background-color: rgba(255, 47, 0, 0.1)
    .info-message__title
      font-size: 14px

  &--warn
    border-color: $nd-warn-border-color
    background-color: rgba(255, 173, 50, 0.1)

  &--delivery
    border-color: #FFCE1F
    background-color: rgba(#FFCE1F, 0.1)
    margin-bottom: 20px
    .info-message__title
      font-weight: 400
      font-size: 14px

.info-message--centered .info-message__title
  text-align: center

.info-message__title
  font-size: 16px
  font-weight: 500
  color: $text-color
  margin: 0
  &-wrap
    display: flex
    align-items: center
    img
      margin-right: 15px

.info-message__text
  font-size: 14px
  font-weight: 400
  color: $text-color
  margin: 10px 0 0

.info-message__text-additional
  font-size: 12px
  font-weight: 400
  color: rgba(51, 51, 51, 0.5)
  margin: 10px 0 0

.info-message__info-btn
  position: absolute
  top: 15px
  right: 15px

::v-deep .info-message__content-wrap
  display: flex
  align-items: flex-start
  flex-flow: row nowrap

  .info-message__content-emoji
    display: block
    flex-shrink: 0
    font-size: 28px
    width: 100%
    max-width: 28px
    margin-right: 20px

  .info-message__text
    width: 100%
    font-weight: 500
    font-size: 14px

</style>
